import React, { useState } from 'react';
import { Section } from './Section';
import { ChevronDown } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Necesito comprar equipo caro?',
  a: 'No, solo necesitas el manual y voluntad para aplicar las reglas de aislamiento.'
}, {
  q: '¿Funciona si tengo hijos o interrupciones?',
  a: 'Sí, el manual incluye una sección específica para gestionar el entorno familiar y social.'
}, {
  q: '¿Es difícil de aprender?',
  a: 'Es un sistema operativo para tu cerebro. Se lee en una hora y se aplica al día siguiente.'
}, {
  q: '¿Qué pasa si mi trabajo requiere estar conectado?',
  a: 'Te enseñamos a crear "Ventanas de Respuesta" para que tú controles el mundo, no al revés.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section className="bg-tactical-gray border-y border-tactical-border" data-id="element-24">
      <h2 className="text-3xl md:text-5xl font-bold text-white uppercase text-center mb-10" data-id="element-25">
        Preguntas <span className="text-accent" data-id="element-26">Frecuentes</span>
      </h2>

      <div className="max-w-3xl mx-auto space-y-4" data-id="element-27">
        {faqs.map((faq, idx) => {
        const isOpen = openIndex === idx;
        return <div key={idx} className="bg-tactical-dark border border-tactical-border overflow-hidden" data-id="element-28">
              <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full px-6 py-5 flex justify-between items-center text-left hover:bg-tactical-light transition-colors" data-id="element-29">
                <span className="text-lg font-oswald text-white uppercase tracking-wide" data-id="element-30">
                  {faq.q}
                </span>
                <ChevronDown className={`w-5 h-5 text-accent transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-31" />
              </button>
              <AnimatePresence data-id="element-32">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-33">
                    <div className="px-6 pb-5 text-zinc-400 text-lg border-t border-tactical-border/50 pt-4" data-id="element-34">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>
    </Section>;
}